import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_delete, api_post } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";

const LOAD_EXPENSES = "LOAD_EXPENSES";
const SET_EXPENSES = "SET_EXPENSES";
const FAILED_EXPENSES = "FAILED_EXPENSES"

const SET_NEW_EXPENSES_RECORD = "SET_NEW_EXPENSES_RECORD";
const SET_NEW_EXPENSES = "SET_NEW_EXPENSES";
const ERROR_NEW_EXPENSES_RECORD = "ERROR_NEW_EXPENSES_RECORD";

const FETCH_DELETE_EXPENSES = "FETCH_DELETE_EXPENSES"
const SUCCESS_DELETE_EXPENSES = "SUCCESS_DELETE_EXPENSES";
const FAILED_DELETE_EXPENSES = "FAILED_DELETE_EXPENSES"

const LOAD_CATEGORY_BY_EXPENSE = "LOAD_CATEGORY_BY_EXPENSE";
const SET_CATEGORY_BY_EXPENSE = "SET_CATEGORY_BY_EXPENSE";
const ERROR_CATEGORY_BY_EXPENSE = "ERROR_CATEGORY_BY_EXPENSE";
const CLEAN_CATEGORY_BY_EXPENSE = "CLEAN_CATEGORY_BY_EXPENSE";

const SET_EXPENSES_FILTERS = "SET_EXPENSES_FILTERS";
const CHANGE_STATION_EXPENSES = "CHANGE_STATION_EXPENSES";
const CHANGE_COMPANY_EXPENSES = "CHANGE_COMPANY_EXPENSES";
const CHANGE_CATEGORY_EXPENSE = "CHANGE_CATEGORY_EXPENSE";
const EDIT_ROW_SELECTED = "EDIT_ROW_SELECTED";
const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
const CLOSE_SNACKBAR_MESSAGE = "CLOSE_SNACKBAR_MESSAGE";
const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
const SET_STATIONS = "SET_STATIONS";
const CHANGE_START_DATE_EXPENSES = "CHANGE_START_DATE_EXPENSES"
const CHANGE_END_DATE_EXPENSES = "CHANGE_END_DATE_EXPENSES";
const CLEAN_PAGE = "CLEAN_PAGE"
const GET_IMAGES = "GET_IMAGES";

// config
const SET_CONFIG_PAGE_EXPENSES = "SET_CONFIG_PAGE_EXPENSES";
const SET_CONFIG_PAGE_SIZE_EXPENSES = "SET_CONFIG_PAGE_SIZE_EXPENSES";
const SET_CONFIG_SORTED_EXPENSES = "SET_CONFIG_SORTED_EXPENSES";
const SET_CONFIG_FILTERED_EXPENSES = "SET_CONFIG_FILTERED_EXPENSES";

const INITIAL_STATE = {
   //data
   expenses: [],
   categories: [],
   stations: [],
   //config
   config: {
      page: 0,
      pageSize: 50,
      sorted: [],
      filtered: [],
   },

   isLoading: false,
   colorError: "danger",
   error: false,
   errorMessage: "",
   stationSelected: [],
   station: [],
   company: {},
   categorySelected: "",
   startDate: null,
   endDate: null,
   images: [],
};


const expensesReducer = (state = INITIAL_STATE, { type, payload }) => {
   switch (type) {
      // categories
      case LOAD_CATEGORY_BY_EXPENSE:
         return {
            ...state,
            isLoading: true,
            error: false,
            errorMessage: "",
         };
      case SET_CATEGORY_BY_EXPENSE:
         return {
            ...state,
            categories: payload.categories,
            isLoading: false,
         };
      case ERROR_CATEGORY_BY_EXPENSE:
         return {
            ...state,
            isLoading: false,
            error: true,
            errorMessage: payload.message,
         };
      case CLEAN_CATEGORY_BY_EXPENSE:
         return {
            ...state,
            ...INITIAL_STATE,
         };
      //expenses
      case CHANGE_START_DATE_EXPENSES:
         return {
            ...state,
            startDate: payload,
         };
      case CHANGE_END_DATE_EXPENSES:
         return {
            ...state,
            endDate: payload,
         };
      case SET_EXPENSES_FILTERS:
         return {
            ...state,
            [payload.key]: payload.data,
         };
      case LOAD_EXPENSES:
         return {
            ...state,
            isLoading: true,
            expenses: [],
         };
      case SET_EXPENSES:
         return {
            ...state,
            isLoading: false,
            expenses: payload.expenses,
         };
      case FAILED_EXPENSES:
         return {
            ...state,
            isLoading: false,
            error: true,
            colorError: "danger",
            errorMessage: payload.message
         }

      case SUCCESS_DELETE_EXPENSES:
         const newState = [...state.expenses];
         const newStateExpenses = newState.filter(expense => expense.id !== payload.response.id)
         return {
            ...state,
            expenses: newStateExpenses
         }
      //new expense
      case SET_NEW_EXPENSES_RECORD:
         return {
            ...state,
            isLoading: true,
         };
      case SET_NEW_EXPENSES:
         const { newBody } = payload;
         const expensesFiltered = newBody.filter(newExpense => state.expenses.filter(expense => expense.idStation === newExpense.idStation).length !== 0)
         const stationsFiltered = state.expenses.length !== 0
            ? [...state.stationSelected.filter(station => state.expenses.filter(expense => expense.idStation === station.value).length !== 0)]
            : [...state.stationSelected];
         const newExpenses = state.expenses.length !== 0
            ? [...state.expenses, ...expensesFiltered]
            : [...newBody];
         return {
            ...state,
            expenses: newExpenses,
            stationSelected: stationsFiltered,
            isLoading: false
         };
      case ERROR_NEW_EXPENSES_RECORD:
         return {
            ...state,
            colorError: "danger",
            error: true,
            errorMessage: payload.message,
            isLoading: false
         };
      case SET_STATIONS:
         return {
            ...state,
            stations: payload.stations
         };
      case CHANGE_STATION_EXPENSES:
         let totalPercent = '100'
         return {
            ...state,
            stationSelected: payload ? payload.map((item) => {
               const percentByRow = totalPercent / payload.length
               return { ...item, percent: percentByRow.toFixed(2) }
            }) : []
         }
      case CHANGE_COMPANY_EXPENSES:
         return {
            ...state,
            company: payload,
         };
      case EDIT_ROW_SELECTED:
         const { value, percent } = payload;
         const newStationSelected = [...state.stationSelected];

         const index = newStationSelected.findIndex((item) => item.value === value);
         if (index !== -1) {
            newStationSelected[index].percent = percent;
         }
         return {
            ...state,
            stationSelected: newStationSelected,
         };
      case CLEAN_PAGE:
         return {
            ...state,
            isLoading: false,
            stationSelected: [],
            expenses: []
         }
      case GET_IMAGES: 
         return {
            ...state,
            images: payload
         }
      //config
      case CLOSE_SNACKBAR_MESSAGE:
         return {
            ...state,
            error: false,
            errorMessage: "",
         }

      case SET_ERROR_MESSAGE:
         return {
            ...state,
            error: true,
            errorMessage: payload.errorMessage,
            colorError: payload.colorError
         }

      case SET_SUCCESS_MESSAGE:
         return {
            ...state,
            colorError: "success",
            error: true,
            errorMessage: payload,
         }
      case SET_CONFIG_FILTERED_EXPENSES:
         return {
            ...state,
            config: {
               ...state.config,
               filtered: payload,
               page: 0,
            },
         };
      case SET_CONFIG_PAGE_EXPENSES:
         return {
            ...state,
            config: {
               ...state.config,
               page: payload,
            },
         };
      case SET_CONFIG_PAGE_SIZE_EXPENSES:
         return {
            ...state,
            config: {
               ...state.config,
               pageSize: payload,
               page: 0,
            },
         };
      case SET_CONFIG_SORTED_EXPENSES:
         return {
            ...state,
            config: {
               ...state.config,
               sorted: payload,
               page: 0,
            },
         };
      default:
         return state;
   }

}
//Config
function setConfigFilter(filter) {
   return {
      type: SET_CONFIG_FILTERED_EXPENSES,
      payload: filter,
   };
}
function setConfigPage(page) {
   return {
      type: SET_CONFIG_PAGE_EXPENSES,
      payload: page,
   };
}
function setConfigPageSize(pageSize) {
   return {
      type: SET_CONFIG_PAGE_SIZE_EXPENSES,
      payload: pageSize,
   };
}
function setConfigSorted(sorted) {
   return {
      type: SET_CONFIG_SORTED_EXPENSES,
      payload: sorted,
   };
}

//actions categories
function getCategories() {
   return {
      type: LOAD_CATEGORY_BY_EXPENSE,
   };
}
//expenses
function getExpenses(stations, startDate, endDate, dispatch) {
   return {
      type: LOAD_EXPENSES,
      payload: {
         stations,
         startDate,
         endDate,
         dispatch
      },
   };
}
function getDeleteExpense(body, dispatch = null, close = null) {
   return {
      type: FETCH_DELETE_EXPENSES,
      payload: body,
      close: close,
      dispatch: dispatch,
   }
}
//New expenses
function newExpense(body, image, onSuccess) {
   return {
      type: SET_NEW_EXPENSES_RECORD,
      payload: {
         body,
         image,
         onSuccess
      }
   }
}
function changeCategory(category) {
   return {
      type: CHANGE_CATEGORY_EXPENSE,
      payload: category,
   };
}
function changeCompany(company) {
   return {
      type: CHANGE_COMPANY_EXPENSES,
      payload: company,
   }
}
function changeStation(stations) {
   return {
      type: CHANGE_STATION_EXPENSES,
      payload: stations,
   }
}
function editRowSelected(body) {
   return {
      type: EDIT_ROW_SELECTED,
      payload: body
   }
}
function closeSnackbar() {
   return {
      type: CLOSE_SNACKBAR_MESSAGE,
   }
}
function setErrorSnackbar(body) {
   return {
      type: SET_ERROR_MESSAGE,
      payload: body
   }
}
function changeStartDate(date) {
   return {
      type: CHANGE_START_DATE_EXPENSES,
      payload: date,
   };
}
function changeEndDate(date) {
   return {
      type: CHANGE_END_DATE_EXPENSES,
      payload: date,
   };
}
function setExpensesFilters(key = "", data) {
   return {
      type: SET_EXPENSES_FILTERS,
      payload: { data, key },
   };
}
function cleanStationSelect() {
   return {
      type: CLEAN_PAGE,
      startDate: null,
      endDate: null,
   }
}
export const checkAvailability = (date, company) => {
   return async (dispatch) => {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/expenses_periods?idCompany=${company?.id}&date=${date}`;

      try {
         const resp = await api_get(url);
         if (!resp?.id || resp?.closedDate) {
            dispatch(setSnackbar(`La empresa ${company.name} esta cerrada, no puedes generar movimientos. Contacte a soporte`, "danger"));
            return false;
         }

         return true;
      } catch (err) {
         const message = err ? err : 'Error en la solicitud';
         dispatch(setSnackbar(message, "danger"));
         return false;
      }
   };
};

export const checkImage = (id, setOpen) => {
   return async (dispatch) => {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses/${id}/files`;
      try {
         const resp = await api_get(url);
         if (!resp?.files) {
            dispatch(setSnackbar(`no hay imágenes a mostrar`, "info"));
            return
         }
         setOpen()
         dispatch({
            type: GET_IMAGES,
            payload: resp?.files
         });
      } catch (err) {
         dispatch(setSnackbar(err, "danger"));
      }
   }
}

// sagas
function* deleteExpense(action) {
   const {
      payload, close, dispatch
   } = action;
   const token = yield select((state) => state.login.token);
   const auth = { headers: { authorization: `${token}` } };
   const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses/${payload.id}`;

   try {
      const response = yield call(api_delete, url, {}, auth);
      yield put({
         type: SUCCESS_DELETE_EXPENSES,
         payload: {
            response
         }
      })
      dispatch(setSnackbar("Eliminado con éxito.", "success"));
      close && close()
   } catch (message) {
      yield put({
         type: FAILED_DELETE_EXPENSES,
         payload: {
            message,
         },
      });
   }
}

function* fetchExpenses(action) {
   const {
      payload: { stations = [], startDate, endDate, dispatch },
   } = action;
   const token = yield select((state) => state.login.token);
   const auth = { headers: { authorization: `${token}` } };
   let baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses?`;

   let urlStations = `start=${startDate}&end=${endDate}`;

   if (stations) {
      stations.forEach((station) => {
         urlStations = `${urlStations}&stations=${station.value}`;
      });
   }
   const url = `${baseUrl}${urlStations}`;

   try {
      dispatch(startRequestComp("loadingExpenses"))
      const response = yield call(api_get, url, auth);

      const expensebyStation = response.reduce((acc, expense) => {
         const { amount, stations } = expense;
         stations.forEach(station => {
            const { id, percentage } = station;
            const amountByStation = Number((percentage / 100) * amount)
            acc.push({
               ...expense,
               idStation: id,
               percentage: percentage.toFixed(2),
               amountByStation: amountByStation.toFixed(2)
            })
         })

         return acc;
      }, [])
      yield put({
         type: SET_EXPENSES,
         payload: {
            expenses: expensebyStation,
         },
      });
      dispatch(stopRequestComp("loadingExpenses"))
   } catch (message) {
      yield put({
         type: FAILED_EXPENSES,
         payload: {
            message,
         },
      });
      dispatch(stopRequestComp("loadingExpenses"))
   }
}

function* fetchData() {
   const categories = yield select((state) => state.expenses.categories);
   if (categories.length !== 0) {
      yield put({
         type: SET_CATEGORY_BY_EXPENSE,
         payload: {
            categories
         },
      });
      return;
   }
   const token = yield select((state) => state.login.token);
   const auth = { headers: { authorization: `${token}` } };
   const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses/categories`;
   try {
      const response = yield call(api_get, url, auth);
      const categoriesNormalized = response.map((category) => {
         return { ...category, value: category.id, label: category.name };
      });

      yield put({
         type: SET_CATEGORY_BY_EXPENSE,
         payload: {
            categories: categoriesNormalized,
         },
      });
   } catch (message) {
      yield put({
         type: ERROR_CATEGORY_BY_EXPENSE,
         payload: {
            message,
         },
      });
   }
}

function* setNewExpense(action) {
   const { body, image, onSuccess } = action.payload;
   const token = yield select((state) => state.login.token);
   const auth = { headers: { authorization: `${token}` } };
   const authImage = { headers: { authorization: `${token}`, 'Content-Type': 'multipart/form-data' } };
   const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses`;
   const formData = new FormData();
   if(image?.length > 0){
      image.map((form) => formData.append("file", form, form.fileName))
   }

   try {
      const response = yield call(api_post, url, body, auth);
      const { amount, stations, id } = response;
      const newBody = stations.map(station => {
         const { idStation, percentage, } = station;
         const amountByStation = Number((percentage / 100) * amount)
         return ({
            ...response,
            idStation,
            percentage: percentage.toFixed(2),
            amountByStation: amountByStation.toFixed(2)
         })
      })

      // Subir archivos
      if(image?.length > 0 ){
         const urlImage = `${process.env.REACT_APP_URL}${PROYECT}/stations/expenses/${id}/files`;
         try {
            yield call(api_post, urlImage, formData, authImage)
         } catch (imgErr) {
            const errorMsg = typeof imgErr === 'string' ? imgErr : "Error al subir el archivo. Verifica el formato.";
            yield put(setSnackbar(`Gasto guardado, pero la imagen no se subió: ${errorMsg}`, "warning"));
         }
      }

      yield put({
         type: SET_NEW_EXPENSES,
         payload: {
            newBody,
         }
      });
      yield put(setSnackbar("Gasto guardado con éxito.", "success"));
      onSuccess && onSuccess();
   } catch (message) {
      const errorMsg = typeof message === 'string' ? message : "Error al crear el gasto.";
      yield put({ type: ERROR_NEW_EXPENSES_RECORD, payload: { message: errorMsg } });
      yield put(setSnackbar(errorMsg, "danger"));
   }
}


function* categoriesSaga() {
   yield takeLatest(LOAD_CATEGORY_BY_EXPENSE, fetchData);
   yield takeLatest(SET_NEW_EXPENSES_RECORD, setNewExpense);
   yield takeLatest(LOAD_EXPENSES, fetchData)
   yield takeLatest(LOAD_EXPENSES, fetchExpenses)
   yield takeLatest(FETCH_DELETE_EXPENSES, deleteExpense)
}



export {
   // config
   setConfigFilter,
   setConfigPage,
   setConfigPageSize,
   setConfigSorted,
   //reducer
   expensesReducer,
   //actions
   setExpensesFilters,
   changeStation,
   changeCompany,
   editRowSelected,
   closeSnackbar,
   setErrorSnackbar,
   getCategories,
   newExpense,
   changeCategory,
   changeStartDate,
   changeEndDate,
   getExpenses,
   cleanStationSelect,
   getDeleteExpense,
   // saga
   categoriesSaga,
   fetchExpenses,
}
